import axios from "axios";
import { AuthModel } from "./_models";
import { getRuntimeConfig } from "@/config/runtimeConfig";

export const GET_USER_BY_ACCESSTOKEN_URL = "/me";
export const LOGIN_URL = "/oauth/token";
export const REGISTER_URL = "/register";
export const REQUEST_PASSWORD_URL = "/forgot_password";
export const REFRESH_TOKEN_URL = "/oauth/token";

// Server should return AuthModel
export function login(username: string, password: string) {
	const { apiUrl, passwordGrantClientId } = getRuntimeConfig();

	return axios.post<AuthModel>(`${apiUrl}${LOGIN_URL}`, {
		grant_type: "password",
		client_id: passwordGrantClientId,
		scope: "*",
		username,
		password,
	});
}

// Server should return AuthModel
export function register(
	email: string,
	firstname: string,
	lastname: string,
	password: string,
	password_confirmation: string
) {
	const { apiUrl } = getRuntimeConfig();

	return axios.post(`${apiUrl}${REGISTER_URL}`, {
		email,
		first_name: firstname,
		last_name: lastname,
		password,
		password_confirmation,
	});
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
	const { apiUrl } = getRuntimeConfig();

	return axios.post<{ result: boolean }>(`${apiUrl}${REQUEST_PASSWORD_URL}`, {
		email,
	});
}
